import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

export default function Header() {

    return (
        <>
            <header>
                <div className="header_top_nav">
                    <div className="container-lg">
                        <div className="header_top_nav_content">
                            <div className="social_media">
                                <ul>
                                    <li>
                                        <a href="https://www.linkedin.com/company/eurokars-group/" target="_blank">
                                            <i className="fa-brands fa-linkedin-in"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/eurokarsgroupsg/" target="_blank">
                                            <i className="fa-brands fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.facebook.com/EurokarsGroup" target="_blank">
                                            <i className="fa-brands fa-facebook-f"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="contect_number">
                                <i className="fi fi-rr-phone-call"></i>
                                <a href="tel:+65 6363 3003">+65 6363 3003</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header_main">
                    <div className="container-lg">
                        <nav className="navbar navbar-expand-md">
                            <div className="navbar-wrap">
                                <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                                    <i className="fi fi-rr-menu-burger"></i>
                                </button>
                                <div className="navbar_logo">
                                    {/* <Navbar.Brand as={Link} to="/landing/"><img src="../assets/image/logo.svg" alt="" /></Navbar.Brand> */}
                                    <Navbar.Brand href="https://eurokarsfinancial.com.sg/"><img src="../assets/image/logo.svg" alt="EuroKars Logo" width="288px" height="36px" /></Navbar.Brand>
                                </div>

                                <div className="collapse navbar-collapse" id="navbarText">
                                    <div className="nav_icon d-md-none d-block">
                                        <img src="../assets/image/home.svg" alt="" />
                                    </div>
                                    <ul className="navbar-nav ms-auto">
                                        <li className="nav-item dropdown navbar-brand-dropdown">
                                            <a className="nav-link dropdown-toggle" href="./financing.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Financing <i className="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul className="dropdown-menu">
                                                <li className="sub_list">
                                                    <Link as={Link} className="dropdown-item" to="/landing/apply-loan">Apply Loan</Link>
                                                </li>
                                                <li className="sub_list">
                                                    <a className="dropdown-item" href="https://hosted-egiro.tryacme.com/eurokarsfinancial">Apply eGIRO</a>
                                                </li>
                                                <li className="sub_list">
                                                    <a className="dropdown-item" href="https://api.whatsapp.com/send/?phone=6586133000&text&type=phone_number&app_absent=0">WhatsApp Us</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item dropdown navbar-brand-dropdown">
                                            <a className="nav-link dropdown-toggle" href="./insurance.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Insurance <i className="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul className="dropdown-menu">
                                                <li className="sub_list">
                                                    <a className="dropdown-item" href="https://eurokarsfinancial.com.sg/get-quotation">Get Quotation</a>
                                                </li>
                                                <li className="sub_list">
                                                    <a className="dropdown-item" href="https://eurokarsfinancial.com.sg/renew-my-policy">Renew My Policy</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" href="https://eurokarsfinancial.com.sg/the-group">The Group</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" href="https://eurokarsfinancial.com.sg/newsroom">Newsroom</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" href="https://eurokarsfinancial.com.sg/contact-us">Contact Us</a>
                                        </li>
                                        <li className="nav-item">
                                            {/* <Link className="nav-link" to="/dealer/">Dealer Sign In</Link> */}
                                            <a className="nav-link" href="https://weberp6.websoft.com.sg/sites/indouniversal/main.php">Dealer Sign In</a>
                                        </li>
                                    </ul>
                                    <div className="button">
                                        <Button as={Link} to="/landing/apply-loan" variant="" className="btn btn_primary">Apply Loan</Button>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
            <header className="header_sticky">
                <div className="header_main">
                    <div className="container-lg">
                        <nav className="navbar navbar-expand-md">
                            <div className="navbar-wrap">
                                <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTextSticky" aria-controls="navbarTextSticky" aria-expanded="false" aria-label="Toggle navigation">
                                    <i className="fi fi-rr-menu-burger"></i>
                                </button>
                                <div className="navbar_logo">
                                    <Navbar.Brand as={Link} to="/landing/"><img src="../assets/image/logo.svg" alt="" /></Navbar.Brand>
                                </div>

                                <div className="collapse navbar-collapse" id="navbarTextSticky">
                                    <div className="nav_icon d-md-none d-block">
                                        <img src="../assets/image/home.svg" alt="" />
                                    </div>
                                    <ul className="navbar-nav ms-auto">
                                        <li className="nav-item dropdown navbar-brand-dropdown">
                                            <a className="nav-link dropdown-toggle" href="./financing.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Financing <i className="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul className="dropdown-menu">
                                                <li className="sub_list">
                                                    <Link as={Link} className="dropdown-item" to="/landing/apply-loan">Apply Loan</Link>
                                                </li>
                                                <li className="sub_list">
                                                    <a className="dropdown-item" href="https://hosted-egiro.tryacme.com/eurokarsfinancial">Apply eGIRO</a>
                                                </li>
                                                <li className="sub_list">
                                                    <a className="dropdown-item" href="https://api.whatsapp.com/send/?phone=6586133000&text&type=phone_number&app_absent=0">WhatsApp Us</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item dropdown navbar-brand-dropdown">
                                            <a className="nav-link dropdown-toggle" href="./insurance.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Insurance <i className="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul className="dropdown-menu">
                                                <li className="sub_list">
                                                    <a className="dropdown-item" href="https://eurokarsfinancial.com.sg/get-quotation">Get Quotation</a>
                                                </li>
                                                <li className="sub_list">
                                                    <a className="dropdown-item" href="https://eurokarsfinancial.com.sg/renew-my-policy">Renew My Policy</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" href="https://eurokarsfinancial.com.sg/the-group">The Group</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" href="https://eurokarsfinancial.com.sg/newsroom">Newsroom</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" href="https://eurokarsfinancial.com.sg/contact-us">Contact Us</a>
                                        </li>
                                        <li className="nav-item">
                                            {/* <Link className="nav-link" to="/dealer/">Dealer Sign In</Link> */}
                                            <a className="nav-link" href="https://weberp6.websoft.com.sg/sites/indouniversal/main.php">Dealer Sign In</a>
                                        </li>
                                    </ul>
                                    <div className="button">
                                        <Button as={Link} to="/landing/apply-loan" variant="" className="btn btn_primary">Apply Loan</Button>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
        </>
    );
}